<template>
  <div class="modal-content">
    <div class="modal-header align-items-center pl-4">
      <h5 class="mb-0">
        {{ p_currentAddress ? '修改收货地址' : '新增收货地址' }}
      </h5>
      <button
        type="button"
        class="btn btn-link text-dark"
        @click.prevent="cancelSubmitAddress"
      >
        <i class="pz-icon icon-close"></i>
      </button>
    </div>
    <!-- <div class="pb-4 ofHeader">
      
    </div> -->
    <div class="modal-body p-md-5">
      <div class="form-group row">
        <label class="col-form-label col-lg-2">收件人</label>
        <div class="col-lg-10">
          <input type="text" name="name" v-model="name" class="form-control" />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-lg-2">所在地区</label>
        <div class="col-lg-10">
          <v-distpicker
            :province="init_province"
            :city="init_city"
            :area="init_area"
            @province="handleChangeProvince"
            @city="handleChangeCity"
            @area="handleChangeArea"
          />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-form-label col-lg-2">详细地址</label>
        <div class="col-lg-10">
          <input
            type="text"
            name="addressDetail"
            v-model="addressDetail"
            class="form-control"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">手机号</label>
        <div class="col-lg-10">
          <input
            type="text"
            size="11"
            maxlength="11"
            name="mobile"
            v-model="mobile"
            class="form-control"
            @input="handleInputMobile"
          />
          <p class="text-danger small mb-0">
            {{
              isShowMobileInvalid && c_isMobileWrongFmt
                ? '电话号码格式不正确。'
                : ''
            }}
          </p>
        </div>
      </div>

      <!-- <div class="form-group row">
        <label class="col-form-label col-lg-2">邮编地址</label>
        <div class="col-lg-10">
          <input
            type="text"
            name="postcode"
            v-model="postcode"
            class="form-control"
          />
        </div>
      </div> -->
      <div class="form-group row" v-if="!c_isHaveAddress">
        <div class="col-lg-10 offset-lg-2">
          <div class="form-check">
            <input
              id="gridCheck1"
              class="form-check-input"
              type="checkbox"
              name="isDefault"
              v-model="isDefault"
            />
            <label for="gridCheck1" class="form-check-label"
              >设为默认地址</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer justify-content-center">
      <button
        :disabled="c_isAddressSubmitDisabled"
        @click.prevent="makeNewAddress"
        class="btn btn-primary btn-lg btn-sm-block mx-3"
      >
        确定
      </button>
      <button
        @click.prevent="cancelSubmitAddress"
        class="btn btn-light btn-lg btn-sm-block mx-3"
      >
        取消
      </button>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import VDistpicker from 'v-distpicker';

import { DEBOUNCE_LATENCY } from '@/constants/index';
import { AddressEditMixin } from '@/mixins/AddressEdit';

export default {
  name: 'AddressEdit',

  mixins: [AddressEditMixin],

  components: {
    'v-distpicker': VDistpicker,
  },

  props: {
    p_currentAddress: {
      type: Object,
      default: () => undefined,
    },
  },

  data() {
    return {
      studentAddressId: -1,
      //
      isDefault: false,
      name: '',
      mobile: '',
      isShowMobileInvalid: false,
      //
      province: '',
      city: '',
      area: '',
      areaCode: '',
      //postcode: '',
      addressDetail: '',

      init_province: '',
      init_city: '',
      init_area: '',
    };
  },

  computed: {
    c_isMobileWrongFmt() {
      return '' !== this.mobile && this.mobile.match(/^\d{11}$/) === null;
    },

    c_isAddressSubmitDisabled() {
      return (
        '' === this.name ||
        '' === this.mobile ||
        this.c_isMobileWrongFmt ||
        '省' === this.province ||
        '市' === this.city ||
        '区' === this.area ||
        '' === this.addressDetail
      );
    },
  },

  methods: {
    _showMobileInvalid() {
      this.isShowMobileInvalid = true;
    },

    handleInputMobile() {
      this.isShowMobileInvalid = false;
      this.de_showMobileInvalid();
    },

    handleChangeProvince(province) {
      this.province = province.value;
      this.areaCode = province.code ? province.code : '';
    },

    handleChangeCity(city) {
      this.city = city.value;
      this.areaCode = city.code ? city.code : this.areaCode;
    },

    handleChangeArea(area) {
      this.area = area.value;
      this.areaCode = area.code ? area.code : this.areaCode;
    },

    _emitAddressEditFinished() {
      this.$emit('address-edit-finished');
    },

    async makeNewAddress() {
      await this.ma_makeNewAddress({
        studentAddressId:
          this.studentAddressId > 0 ? this.studentAddressId : undefined,
        isDefault: !this.c_isHaveAddress ? true : this.isDefault,
        name: this.name,
        mobile: this.mobile,
        province: this.province,
        city: this.city,
        area: this.area,
        areaCode: this.areaCode,
        //postcode: this.postcode,
        addressDetail: this.addressDetail,
      });
      this._emitAddressEditFinished();
    },

    cancelSubmitAddress() {
      this._emitAddressEditFinished();
    },

    _AddressEditCreated() {
      this.de_showMobileInvalid = _.debounce(
        this._showMobileInvalid,
        DEBOUNCE_LATENCY
      );
      if (this.p_currentAddress) {
        this.studentAddressId = this.p_currentAddress.studentAddressId;
        //
        this.isDefault = this.p_currentAddress.isDefault;
        this.name = this.p_currentAddress.name;
        this.mobile = this.p_currentAddress.mobile;
        this.init_province = this.p_currentAddress.province;
        this.init_city = this.p_currentAddress.city;
        this.init_area = this.p_currentAddress.area;
        this.province = this.p_currentAddress.province;
        this.city = this.p_currentAddress.city;
        this.area = this.p_currentAddress.area;
        this.areaCode = this.p_currentAddress.areaCode;
        //this.postcode = this.p_currentAddress.postcode;
        this.addressDetail = this.p_currentAddress.addressDetail;
      }
    },
  },

  created() {
    this._AddressEditCreated();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ofHeader {
  position: relative;
}
button.close {
  position: absolute;
  right: 0px;
  top: 0px;
}
</style>
